export default "__VITE_ASSET__Cpn5Wo7Y__"